import { render, staticRenderFns } from "./localChaindetail.vue?vue&type=template&id=453c4baa&scoped=true&"
import script from "./localChaindetail.vue?vue&type=script&lang=js&"
export * from "./localChaindetail.vue?vue&type=script&lang=js&"
import style0 from "./localChaindetail.vue?vue&type=style&index=0&id=453c4baa&scoped=scoped&lang=css&"
import style1 from "./localChaindetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c4baa",
  null
  
)

export default component.exports